<template>
    <div>
        <div class="main-button-bar">
            <el-row>
                <el-select
                    v-model="params.shopId"
                    clearable
                    placeholder="选择店铺"
                    class="taobao-order-search"
                >
                    <el-option
                        v-for="item in shops"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-select
                    v-model="params.channelId"
                    clearable
                    placeholder="选择渠道"
                    class="taobao-order-search"
                >
                    <el-option
                        v-for="item in channels"
                        :key="item.id"
                        :label="item.name"
                        :value="item.id"
                    ></el-option>
                </el-select>

                <el-select
                    v-model="params.statusId"
                    clearable
                    placeholder="订单状态"
                    class="taobao-order-search"
                >
                    <el-option v-for="item in status" :key="item" :label="item" :value="item"></el-option>
                </el-select>
                <el-input
                    v-model="params.orderId"
                    style="width:217px"
                    placeholder="订单编号"
                    class="taobao-order-search"
                ></el-input>
            </el-row>

            <el-row>
                <el-date-picker
                    type="date"
                    placeholder="起始下单日期"
                    v-model="params.startTime"
                    style="width:217px"
                    class="taobao-order-search"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-date-picker
                    type="date"
                    placeholder="截止下单日期"
                    v-model="params.endTime"
                    style="width:217px"
                    class="taobao-order-search"
                    value-format="yyyy-MM-dd"
                ></el-date-picker>
                <el-input
                    v-model="params.userName"
                    style="width:217px"
                    placeholder="下单用户"
                    class="taobao-order-search"
                ></el-input>
                <el-button
                    type="primary"
                    size="small"
                    class="taobao-order-search"
                    @click="page(1)"
                >搜索</el-button>
                <el-link class="taobao-order-search" type="primary" @click="getTotle">查看统计数据</el-link>
            </el-row>
        </div>
        <el-table
            :data="records"
            stripe
            style="width: 100%"
            :height="this.$tools.mainHeight() - 150"
            class="taobao-order-table"
        >
            <el-table-column prop="id" label="订单编号" width="200"></el-table-column>
            <el-table-column prop="shopName" label="店铺名称" width="100"></el-table-column>
            <el-table-column prop="channelName" label="所属渠道" width="80"></el-table-column>
            <el-table-column prop="user" label="下单用户" width="200"></el-table-column>
            <el-table-column prop="createTime" label="订单时间" width="180">
                <template slot-scope="order">{{ $tools.timestampToTime(order.row.createTime)}}</template>
            </el-table-column>
            <el-table-column prop="num" label="数量" width="50"></el-table-column>
            <el-table-column prop="status" label="订单状态" width="100"></el-table-column>
            <el-table-column prop="cost" label="订单金额" width="100">
                <template slot-scope="order">{{ $tools.parsecost(order.row.cost, true)}}</template>
            </el-table-column>

            <el-table-column label="操作" width="180">
                <template slot-scope="shop">
                    <el-button type="text" size="small"></el-button>
                </template>
            </el-table-column>
        </el-table>

        <el-pagination
            small
            layout="total, prev, pager, next"
            :total="params.total"
            @current-change="page"
            :current-page.sync="params.current"
            :page-size.sync="params.size"
        ></el-pagination>

        <el-drawer
            :visible.sync="showTotal"
            direction="rtl"
            :modal="false"
            :modal-append-to-body="false"
            size="800px"
            :withHeader="false"
        >
            <div :style="'height:' + (this.$tools.mainHeight() + 60) + 'px;overflow:auto;'">
                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>基本统计</span>
                    </div>
                    <el-table :data="totle.base" style="width: 100%">
                        <el-table-column prop="shopName" label="店铺" width="150"></el-table-column>
                        <el-table-column prop="channelName" label="渠道" width="150"></el-table-column>
                        <el-table-column prop="number" label="单量" width="50"></el-table-column>
                        <el-table-column prop="cost" label="总额" width="100">
                            <template slot-scope="order">{{ $tools.parsecost(order.row.cost, true)}}</template>
                        </el-table-column>
                    </el-table>
                </el-card>

                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>销量趋势</span>
                    </div>
                    <div id="saleNumber"></div>
                </el-card>

                <el-card class="box-card">
                    <div slot="header" class="clearfix">
                        <span>销售额趋势</span>
                    </div>
                    <div id="saleCost"></div>
                </el-card>
            </div>
        </el-drawer>
    </div>
</template>

<script>
import { Chart } from "@antv/g2";

export default {
    data() {
        return {
            showTotal: false,
            totle: { base: null },
            char: { saleNumber: null, saleCost: null },
            shops: null,
            channels: null,
            status: [
                "等待买家付款",
                "买家已付款",
                "卖家已发货",
                "交易成功",
                "交易关闭",
                "待付款和待发货订单",
                "未完成的订单",
                "退款中的订单",
                "定金已付",
                "异常订单",
            ],
            params: {
                shopId: null,
                channelId: null,
                statusId: null,
                userName: null,
                startTime: null,
                endTime: null,
                current: null,
                orders: null,
                total: null,

                orderId: null,
                size: 15,
            },
            records: null,
        };
    },
    methods: {
        getShop() {
            let _this = this;

            _this.$http.post(
                ["taobao/shop/all"],
                [
                    function (data) {
                        _this.shops = data;
                    },
                ],
                "none"
            );
        },
        getChannel() {
            let _this = this;

            _this.$http.post(
                ["taobao/channel/all"],
                [
                    function (data) {
                        _this.channels = data;
                    },
                ],
                "none"
            );
        },
        page(current) {
            let _this = this;

            _this.params.current = current ? current : 0;

            _this.$http.post(
                ["taobao/order/page", _this.params],
                [
                    function (data) {
                        _this.params.total = data.total;
                        _this.records = data.records;
                    },
                ],
                ".taobao-order-table"
            );
        },
        getTotle() {
            let _this = this;

            _this.showTotal = true;

            _this.$http.post(
                ["taobao/order/totle", _this.params],
                [
                    function (data) {
                        if (data.sale) {
                            for (var i in data.sale) {
                                data.sale[i].cost = _this.$tools.parsecost(
                                    data.sale[i].cost
                                );
                            }
                        }
                        _this.totle = data;

                        _this.initsale();
                    },
                ],
                ".taobao-order-table"
            );
        },
        initsale() {
            if (this.char.saleNumber == null) {
                this.char.saleNumber = new Chart({
                    container: "saleNumber",
                    autoFit: true,
                    height: 250,
                });
            }

            this.char.saleNumber
                .line()
                .position("time*number")
                .color("lineName");
            this.char.saleNumber.data(this.totle.sale);
            this.char.saleNumber.scale({ number: { min: 0 } });
            this.char.saleNumber.render();

            if (this.char.saleCost == null) {
                this.char.saleCost = new Chart({
                    container: "saleCost",
                    autoFit: true,
                    height: 250,
                });
            }

            this.char.saleCost
                .interval()
                .position("time*cost")
                .color("lineName")
                .adjust(["stack"]);

            this.char.saleCost.data(this.totle.sale);
            this.char.saleCost.scale({ cost: { min: 0 } });
            this.char.saleCost.render();

            this.char.saleCost.tooltip({
                shared: true,
                customContent: (name, items) => {
                    const container = document.createElement("div");
                    container.className = "g2-tooltip";

                    let html = [];
                    html.push(`<div class="g2-tooltip-title" style="margin-top: 12px;margin-bottom: 12px;">${name}</div>`);

                    let count = window.parseFloat(0);
                    items.forEach((item) => {
                        html.push(`<li class="g2-tooltip-list-item" data-index={index} style="margin-bottom:4px;display:flex;align-items: center;">`);
                        html.push(` <span style="background-color:${item?.mappingData?.color || item?.color};" class="g2-tooltip-marker"></span>`);
                        html.push(` <span style="display:inline-flex;flex:1;justify-content:space-between">`);
                        html.push(`     <span style="margin-right: 16px;">${item?.name}:</span><span>${item?.value}</span>`);
                        html.push(` </span>`);
                        html.push(`</li>`);
                        count += window.parseFloat(item.value);
                    });

                    html.push(`<li class="g2-tooltip-list-item" style="margin-bottom:4px;display:flex;align-items: center;">`);
                    html.push(` <span style="background-color:#BBB;" class="g2-tooltip-marker"></span>`);
                    html.push(` <span style="display:inline-flex;flex:1;justify-content:space-between">`);
                    html.push(`     <span style="margin-right: 16px;">共计:</span><span>`, count, `</span>`);
                    html.push(` </span>`);
                    html.push(`</li>`);

                    container.innerHTML = html.join("");
                    return container;
                },
            });
        },
    },
    mounted() {
        this.getShop();
        this.getChannel();
        this.page(1);
    },
};
</script>

<style lang="scss">
.taobao-order-search {
    margin: 5px;
}
</style>